import React from 'react';
import { FadeIn } from './FadeIn';
export function Guarantee() {
  return <section className="py-20 px-4 bg-carbon-950 border-t border-carbon-800" data-id="element-69">
      <div className="max-w-3xl mx-auto text-center" data-id="element-70">
        <FadeIn data-id="element-71">
          <div className="inline-flex items-center justify-center w-16 h-16 border border-electric bg-electric/5 rounded-full mb-8" data-id="element-72">
            <span className="font-display text-3xl text-electric" data-id="element-73">7</span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-display text-white mb-6 uppercase tracking-wide" data-id="element-74">
            La garantía es simple porque el producto es serio.
          </h2>
          <p className="text-lg text-carbon-300 font-sans leading-relaxed mb-10" data-id="element-75">
            Abrís los tomos. Los aplicás en tu entrenamiento. Si en 7 días no es
            exactamente lo que esperabas, te devolvemos el 100% del dinero. Sin
            formularios. Sin preguntas. Sin drama.
          </p>
          <div className="border border-carbon-800 bg-carbon-900 rounded-2xl p-6 inline-block" data-id="element-76">
            <p className="text-electric font-display text-xl uppercase tracking-wide" data-id="element-77">
              La tasa de devolución es menor al 1%.
            </p>
            <p className="text-sm text-carbon-400 font-sans mt-2" data-id="element-78">
              No porque tengamos una política difícil. Sino porque el sistema
              funciona y los atletas que lo implementan lo ven rápido.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}